import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const GamersIcon = ({ color = '#333131' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="28px"
			viewBox="0 0 31 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.6667 24.25V21.6667C21.6667 20.2964 21.1223 18.9822 20.1534 18.0133C19.1844 17.0443 17.8703 16.5 16.5 16.5H6.16667C4.79638 16.5 3.48222 17.0443 2.51328 18.0133C1.54434 18.9822 1 20.2964 1 21.6667V24.25"
				stroke="#333131"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.3335 11.3333C14.1869 11.3333 16.5001 9.02014 16.5001 6.16667C16.5001 3.3132 14.1869 1 11.3335 1C8.48 1 6.16681 3.3132 6.16681 6.16667C6.16681 9.02014 8.48 11.3333 11.3335 11.3333Z"
				stroke="#333131"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M29.4168 24.2501V21.6667C29.416 20.522 29.0349 19.4099 28.3336 18.5051C27.6322 17.6004 26.6502 16.9542 25.5418 16.668"
				stroke="#333131"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20.375 1.16785C21.4864 1.4524 22.4714 2.09875 23.1749 3.005C23.8783 3.91124 24.2601 5.02583 24.2601 6.17305C24.2601 7.32027 23.8783 8.43487 23.1749 9.34111C22.4714 10.2474 21.4864 10.8937 20.375 11.1783"
				stroke="#333131"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
